// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAuthorSchema } from '../author/AuthorSchema';
import type { IBuildingForMobileSiteSchema } from '../building/BuildingForMobileSiteSchema';
import type { IDiscountSchema } from '../discount/DiscountSchema';
import type { IFactoidSchema } from '../factoid/FactoidSchema';
import type { IOfferFeaturesSchema } from '../offer_features/OfferFeaturesSchema';
import type { IGeoForMobileSiteSchema } from '../geo/GeoForMobileSiteSchema';
import type { IGroupedOffersSchema } from '../grouped_offers/GroupedOffersSchema';
import type { IIdenticalOffersSchema } from '../identical/IdenticalOffersSchema';
import type { IMediaSchema } from '../media/MediaSchema';
import type { IInfiniteSearchResultSchema } from '../get_ml_suggestions/InfiniteSearchResultSchema';
import type { IModerationInfoSchema } from '../moderation_info/ModerationInfoSchema';
import type { INewbuildingDynamicCalltrackingSchema } from '../newbuilding_dynamic_calltracking/NewbuildingDynamicCalltrackingSchema';
import type { IOfferInfoSchema } from '../offer_info/OfferInfoSchema';
import type { IPessimizationSchema } from '../pessimization/PessimizationSchema';
import type { IPhotoFeatureIconSchema } from '../photo_feature_icon/PhotoFeatureIconSchema';
import type { IPhotoLabelSchema } from '../media/PhotoLabelSchema';
import type { IPriceForMobileSiteSchema } from '../price/PriceForMobileSiteSchema';
import type { IPromoSuburbanSchema } from '../promo/PromoSuburbanSchema';
import type { IPuidsSchema } from '../puids/PuidsSchema';
import type { IVillageForMobileSiteSchema } from '../village/VillageForMobileSiteSchema';
import type { IVillageAdvantageSchema } from '../village_advantage/VillageAdvantageSchema';

export interface IOfferForMobileSiteSchema {
  /** Цена за квадратный метр **/
  additionalPrice?: string;
  /** Признаки объявлений (ЭТП, Залоговая, Аукцион) **/
  agentLists?: string[];
  /** Автор объявления **/
  author?: IAuthorSchema;
  /** Уровень брендинга **/
  brandingLevel?: EBrandingLevel;
  /** Информация о корпусе новостройки/ЖК **/
  building?: IBuildingForMobileSiteSchema;
  /** Текст на кнопке звонка **/
  callButtonTitle?: string;
  /** Объявление свободно на даты, можно забронировать **/
  canBeBooked?: boolean;
  /** Категория объявления **/
  category: ECategory;
  /** Cian ID объявления **/
  cianId: number;
  /** Версия cделки в аренде **/
  dealRentMonetization?: EDealRentMonetization;
  /** Версия cделки в аренде **/
  dealRentVersion?: EDealRentVersion;
  /** Тип сделки **/
  dealType: EDealType;
  /** Описание объявления **/
  description: string;
  /** Скидка **/
  discount?: IDiscountSchema;
  /** Ссылка на объявление на сайте партнера **/
  externalOfferUrl?: string;
  /** Фактоиды **/
  factoids?: IFactoidSchema[];
  /** Характеристики объекта **/
  features: IOfferFeaturesSchema;
  /** Объявление создано с помощью импорта **/
  fromImport?: boolean;
  /** Строка для передачи в аналитику при расхлопе **/
  gaLabel: string;
  /** Гео-данные **/
  geo: IGeoForMobileSiteSchema;
  /** Еще такие же квартиры в этом доме **/
  groupedOffers?: IGroupedOffersSchema;
  /** Признак наличия 3д тура **/
  hasTour?: boolean;
  /** Список иконок VAS'ов **/
  icons: EIcons[];
  /** Realty ID объявления **/
  id: number;
  /** Информация о дубликатах **/
  identicalOffers?: IIdenticalOffersSchema;
  /** Забронирована ли квартира у застройщика **/
  isBookedFromDeveloper?: boolean;
  /** Подключен ли колтрекинг **/
  isCalltrackingEnabled?: boolean;
  /** Объявление от партнера Циан **/
  isCianPartner?: boolean;
  /** У объявления подключена опция Выделения Цветом **/
  isColorized: boolean;
  /** Признак наличия внешнего 3д тура **/
  isExternalTourAvailable?: boolean;
  /** Объявление в избранном у пользователя **/
  isFavorite: boolean;
  /** У объявления подключена опция ТОП **/
  isPromoted: boolean;
  /** Проверен ли хотя бы один кадастровый номер объявления в росреестре **/
  isRosreestrChecked?: boolean;
  /** Флаг "просмотренности" объявления **/
  isViewedOffer?: boolean;
  /** Список фото **/
  media: IMediaSchema[];
  /** Данные бесконечного поиска необходимые для отчетных событий **/
  mlSuggestionsInfiniteSearchResult?: IInfiniteSearchResultSchema;
  /** Данные об отображении объявления от модерации **/
  moderationInfo?: IModerationInfoSchema;
  /** Данные для динамического коллтрекинга новостроек **/
  newbuildingDynamicCalltracking?: INewbuildingDynamicCalltrackingSchema;
  /** Id ЖК **/
  newbuildingId?: number;
  /** Сделка в аренде **/
  offerInDeal?: boolean;
  /** Информация о предложении: тип, комиссия, предоплата и т.д. **/
  offerInfo: IOfferInfoSchema;
  /** Тип объявления **/
  offerType: EOfferType;
  /** Пессимизация **/
  pessimization?: IPessimizationSchema;
  /** Список телефонов объявления в формате +74959998877 **/
  phones: string[];
  /** Иконки фичей объявления(наличие 3д-тура, записи на просмотр и тд.) **/
  photoFeatureIcons?: IPhotoFeatureIconSchema[];
  /** Лейбл на фото. Устаревшее, см. photo_labels **/
  photoLabel?: IPhotoLabelSchema;
  /** Лейблы на фото **/
  photoLabels: IPhotoLabelSchema[];
  /** Цена **/
  price: IPriceForMobileSiteSchema;
  /** Акции для загородки **/
  promoSuburban?: IPromoSuburbanSchema[];
  /** PUID'ы для рекламы **/
  puids: IPuidsSchema;
  /** Показывать ли предупреждение о недопустимости предоплаты **/
  showWarningMessage?: boolean;
  /** Ссылка на торги на электронной площадке **/
  tradingLink?: string;
  /** VAS заголовок **/
  vasTitle?: string;
  /** Информация о КП **/
  village?: IVillageForMobileSiteSchema;
  /** Преимущества КП **/
  villageAdvantages?: IVillageAdvantageSchema[];
  /** Доступна ли по объявлению сельская ипотека **/
  villageMortgageAllowed?: boolean;
}
export enum EBrandingLevel {
  'FirstLevel' = 'firstLevel',
  'SecondLevel' = 'secondLevel',
  'ThirdLevel' = 'thirdLevel',
}
export enum ECategory {
  /** Аренда койко-места **/
  'BedRent' = 'bedRent',
  /** Аренда здания **/
  'BuildingRent' = 'buildingRent',
  /** Продажа здания **/
  'BuildingSale' = 'buildingSale',
  /** Аренда готового бизнеса **/
  'BusinessRent' = 'businessRent',
  /** Продажа готового бизнеса **/
  'BusinessSale' = 'businessSale',
  /** Аренда автосервис **/
  'CarServiceRent' = 'carServiceRent',
  /** Продажа автосервиса **/
  'CarServiceSale' = 'carServiceSale',
  /** Аренда коммерческой земли **/
  'CommercialLandRent' = 'commercialLandRent',
  /** Продажа коммерческой земли **/
  'CommercialLandSale' = 'commercialLandSale',
  /** Аренда коттеджа **/
  'CottageRent' = 'cottageRent',
  /** Продажа коттеджа **/
  'CottageSale' = 'cottageSale',
  /** Посуточная аренда койко-места **/
  'DailyBedRent' = 'dailyBedRent',
  /** Посуточная аренда квартиры **/
  'DailyFlatRent' = 'dailyFlatRent',
  /** Посуточная аренда дома, дачи, коттеджа **/
  'DailyHouseRent' = 'dailyHouseRent',
  /** Посуточная аренда комнаты **/
  'DailyRoomRent' = 'dailyRoomRent',
  /** Аренда помещения под бытовые услуги **/
  'DomesticServicesRent' = 'domesticServicesRent',
  /** Продажа помещения под бытовые услуги **/
  'DomesticServicesSale' = 'domesticServicesSale',
  /** Аренда квартиры **/
  'FlatRent' = 'flatRent',
  /** Продажа квартиры **/
  'FlatSale' = 'flatSale',
  /** Продажа доли в квартире **/
  'FlatShareSale' = 'flatShareSale',
  /** Аренда помещения свободного назначения **/
  'FreeAppointmentObjectRent' = 'freeAppointmentObjectRent',
  /** Продажа помещения свободного назначения **/
  'FreeAppointmentObjectSale' = 'freeAppointmentObjectSale',
  /** Аренда гаража **/
  'GarageRent' = 'garageRent',
  /** Продажа гаража **/
  'GarageSale' = 'garageSale',
  /** Аренда дома/дачи **/
  'HouseRent' = 'houseRent',
  /** Продажа дома/дачи **/
  'HouseSale' = 'houseSale',
  /** Аренда части дома **/
  'HouseShareRent' = 'houseShareRent',
  /** Продажа части дома **/
  'HouseShareSale' = 'houseShareSale',
  /** Аренда производства **/
  'IndustryRent' = 'industryRent',
  /** Продажа производство **/
  'IndustrySale' = 'industrySale',
  /** Продажа участка **/
  'LandSale' = 'landSale',
  /** Продажа квартиры в новостройке **/
  'NewBuildingFlatSale' = 'newBuildingFlatSale',
  /** Аренда офиса **/
  'OfficeRent' = 'officeRent',
  /** Продажа офиса **/
  'OfficeSale' = 'officeSale',
  /** Аренда общепита **/
  'PublicCateringRent' = 'publicCateringRent',
  /** Продажа общепита **/
  'PublicCateringSale' = 'publicCateringSale',
  /** Аренда комнаты **/
  'RoomRent' = 'roomRent',
  /** Продажа комнаты **/
  'RoomSale' = 'roomSale',
  /** Аренда торговой площади **/
  'ShoppingAreaRent' = 'shoppingAreaRent',
  /** Продажа торговой площади **/
  'ShoppingAreaSale' = 'shoppingAreaSale',
  /** Аренда таунхауса **/
  'TownhouseRent' = 'townhouseRent',
  /** Продажа таунхауса **/
  'TownhouseSale' = 'townhouseSale',
  /** Аренда склада **/
  'WarehouseRent' = 'warehouseRent',
  /** Продажа склада **/
  'WarehouseSale' = 'warehouseSale',
}
export enum EDealRentMonetization {
  /** Комиссию платит собственник **/
  'FeeByHomeowner' = 'feeByHomeowner',
  /** Комиссию платит арендатор **/
  'FeeByRenter' = 'feeByRenter',
  /** Комиссия включена в цену объявления **/
  'FeeIncludedInOfferPrice' = 'feeIncludedInOfferPrice',
}
export enum EDealRentVersion {
  'V1' = 'v1',
  'V2' = 'v2',
}
export enum EDealType {
  /** Аренда **/
  'Rent' = 'rent',
  /** Продажа **/
  'Sale' = 'sale',
}
export enum EIcons {
  /** Аукцион **/
  'Auction' = 'auction',
  /** От застройщика **/
  'Builder' = 'builder',
  /** Выделение цветом **/
  'Colorized' = 'colorized',
  /** Честная игра **/
  'FairPlay' = 'fairPlay',
  /** Платное **/
  'Payed' = 'payed',
  /** Премиум **/
  'Premium' = 'premium',
  /** Объявление разместил профи **/
  'Pro' = 'pro',
  /** Продвижение "Стандарт" **/
  'Standard' = 'standard',
  /** ТОП-3 **/
  'Top3' = 'top3',
}
export enum EOfferType {
  /** коммерческая **/
  'Commercial' = 'commercial',
  /** квартиры **/
  'Flat' = 'flat',
  /** новостройки **/
  'Newobject' = 'newobject',
  /** загородка **/
  'Suburban' = 'suburban',
}
